export type OtsTransportCategoryIconProps = {
  /** WATER, OIL, or anything else for the neutral colour. */
  category?: string;
  className?: string;
  /** An exact color in place of the category's theme color, e.g. to match the pipeline status icons. */
  color?: string;
};

/** Text colour for a transport category: water and oil have their own, everything else is muted. */
export const transportCategoryColorClass = (category?: string) => category?.toUpperCase() === "OIL"
  ? "text-[var(--ots-transport-category-oil)]"
  : category?.toUpperCase() === "WATER"
    ? "text-[var(--ots-transport-category-water)]"
    : "text-[var(--ots-text-muted)]";

/** Foundational droplet marking a transport category, coloured for water, oil, or neither. Decorative. */
export const OtsTransportCategoryIcon = ({category, className, color}: OtsTransportCategoryIconProps) => <svg
  viewBox="0 0 24 24"
  fill={color ?? "currentColor"}
  aria-hidden="true"
  data-category={category?.toUpperCase()}
  className={[color ? undefined : transportCategoryColorClass(category), className].filter(Boolean).join(" ")}>
  <path d="M12 2.25c-.45 0-.86.2-1.14.55C8.98 5.14 5.25 10.12 5.25 14.25a6.75 6.75 0 0 0 13.5 0c0-4.13-3.73-9.11-5.61-11.45A1.46 1.46 0 0 0 12 2.25Z"/>
</svg>;
